import React from 'react';
import { Breadcrumbs as MUIBreadcrumbs, Typography, Link, Box } from '@mui/material';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { useOrg } from '../contexts/OrgContext';

const Breadcrumbs = () => {
  const { org } = useOrg();
  const location = useLocation();
  
  const pathSegments = location.pathname.split('/').filter(Boolean);
  
  if (!org || !pathSegments.includes('internal')) {
    return null;
  }
  
  const orgName = org === 'bare' ? 'Bare' : 'EPL';
  
  // Handle different page types
  let breadcrumbPath = [];
  
  if (pathSegments.includes('companies') && pathSegments.length > 4) {
    // Company detail page: Client Management > [Company Name] > [Tab]
    breadcrumbPath = ['Client Management'];
    const companyId = pathSegments[4];
    if (companyId) {
      breadcrumbPath.push('Company Detail');
      if (pathSegments[5]) {
        const tabName = pathSegments[5]
          .split('-')
          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ');
        breadcrumbPath.push(tabName);
      }
    }
  } else if (pathSegments.includes('crm')) {
    breadcrumbPath = ['Client Management', 'CRM Dashboard'];
  } else {
    const currentPage = pathSegments[pathSegments.length - 1];
    const pageName = currentPage
      .split('-')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
    breadcrumbPath = [pageName];
  }

  return (
    <Box sx={{ 
      mb: 2,
      pl: { xs: 6, md: 0 } // Add left padding on mobile to avoid hamburger overlap
    }}>
      <MUIBreadcrumbs separator=">" sx={{ fontSize: '0.875rem', color: '#64748b' }}>
        <Link
          component={RouterLink}
          to={`/internal/${org}/dashboard`}
          sx={{ 
            color: '#64748b', 
            textDecoration: 'none',
            '&:hover': { color: org === 'bare' ? '#5c725c' : '#0d9488' }
          }}
        >
          {orgName}
        </Link>
        {breadcrumbPath.map((crumb, index) => {
          if (index === breadcrumbPath.length - 1) {
            return (
              <Typography key={index} sx={{ color: '#374151', fontWeight: 500 }}>
                {crumb}
              </Typography>
            );
          } else {
            return (
              <Typography key={index} sx={{ color: '#64748b' }}>
                {crumb}
              </Typography>
            );
          }
        })}
      </MUIBreadcrumbs>
    </Box>
  );
};

export default Breadcrumbs;
